/* eslint-disable no-console */
import { client } from "./supabase";

export const TIPOS_PAGO_EMPLEADO = ["sueldo", "adelanto", "comision", "bono", "finiquito", "transporte"];
export const TIPOS_REQUIEREN_PERIODO = ["sueldo", "adelanto", "comision"];

export const getPagosEmpleados = async ({ pais, desde, hasta, empleadoId } = {}) => {
  try {
    let q = client
      .from("pagos_empleados")
      .select("*, empleados!inner(id, nombre, apellido, pais)")
      .order("fecha_pago", { ascending: false });
    if (pais) q = q.eq("empleados.pais", pais);
    if (desde) q = q.gte("fecha_pago", desde);
    if (hasta) q = q.lte("fecha_pago", hasta);
    if (empleadoId) q = q.eq("empleado_id", empleadoId);
    const { data, error } = await q;
    if (error) throw error;
    return data || [];
  } catch (error) {
    console.error("Error en getPagosEmpleados:", error);
    throw error;
  }
};

export const getPagosPorMovimientos = async (movIds = []) => {
  if (movIds.length === 0) return [];
  try {
    const { data, error } = await client.from("pagos_empleados").select("*").in("movimiento_bancario_id", movIds);
    if (error) throw error;
    return data || [];
  } catch (error) {
    console.error("Error en getPagosPorMovimientos:", error);
    throw error;
  }
};

export const getPagosEmpleadoMes = async (empleadoId, año, mes) => {
  try {
    const { data, error } = await client
      .from("pagos_empleados")
      .select("*")
      .eq("empleado_id", empleadoId)
      .eq("periodo_año", año)
      .eq("periodo_mes", mes);
    if (error) throw error;
    return data || [];
  } catch (error) {
    console.error("Error en getPagosEmpleadoMes:", error);
    throw error;
  }
};

export const crearPagosEmpleado = async (rows = []) => {
  if (rows.length === 0) return [];
  try {
    const { data, error } = await client.from("pagos_empleados").insert(rows).select();
    if (error) throw error;
    return data || [];
  } catch (error) {
    console.error("Error en crearPagosEmpleado:", error);
    throw error;
  }
};

export const actualizarPagoEmpleado = async (id, cambios) => {
  try {
    const { data, error } = await client.from("pagos_empleados").update(cambios).eq("id", id).select();
    if (error) throw error;
    return data?.[0];
  } catch (error) {
    console.error("Error en actualizarPagoEmpleado:", error);
    throw error;
  }
};

export const eliminarPagoEmpleado = async (id) => {
  try {
    const { error } = await client.from("pagos_empleados").delete().eq("id", id);
    if (error) throw error;
    return true;
  } catch (error) {
    console.error("Error en eliminarPagoEmpleado:", error);
    throw error;
  }
};

export const eliminarPagosPorMovimiento = async (movId) => {
  try {
    const { error } = await client.from("pagos_empleados").delete().eq("movimiento_bancario_id", movId);
    if (error) throw error;
    return true;
  } catch (error) {
    console.error("Error en eliminarPagosPorMovimiento:", error);
    throw error;
  }
};

// Suma de lo ya pagado para un empleado en un período dado, solo tipos que restan del líquido devengado
export const sumarPagadoLiquido = (pagos, empleadoId, año, mes) =>
  pagos
    .filter(
      (p) =>
        p.empleado_id === empleadoId &&
        p.periodo_año === año &&
        p.periodo_mes === mes &&
        (p.tipo === "sueldo" || p.tipo === "adelanto")
    )
    .reduce((s, p) => s + Number(p.monto || 0), 0);
